import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import Auth from '@/components/Auth.vue'
import Index from '@/components/Index'
import EditPage from '@/components/Edit-Page'
import PreviewPage from '@/components/Preview-Page'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: { requiresAuth: true }
    },
    {
      path: '/auth',
      component: Auth
    },
    {
      name: 'edit',
      path: '/edit/:id',
      component: EditPage,
      meta: { requiresAuth: true }
    },
    {
      name: 'preview',
      path: '/preview/:id',
      component: PreviewPage
    },
    {
      name: 'static',
      path: '/static/*',
      meta: { requiresAuth: false }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!firebase.auth().currentUser) {
      next({
        path: '/auth',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js